import { Button, Tooltip } from 'antd';
import { FunctionComponent, MouseEventHandler } from 'react';

import Icon from 'utils/icon';

interface ListButtonProps {
	type:
		| 'download'
		| 'accept'
		| 'reject'
		| 'view'
		| 'edit'
		| 'delete'
		| 'suspend'
		| 'reset_password'
		| 'vote'
		| 'request'
		| 'unsuspend'
		| 'excel'
		| 'openAttendance'
		| 'endMeeting'
		| 'endVote'
		| 'note';
	text?: string;
	onClick?: MouseEventHandler<HTMLElement>;
	svgWidth?: number;
	svgHeight?: number;
	disabled?: boolean;
	disabledText?: string;
}

const ListButton: FunctionComponent<ListButtonProps> = ({ type, text, svgWidth, svgHeight, disabled, disabledText, onClick }) => {
	return (
		<Tooltip title={disabled && disabledText ? disabledText : text} color={disabled && disabledText ? 'red' : undefined}>
			<Button
				style={{ width: '40px', height: '40px' }}
				disabled={disabled}
				color={
					type === 'delete' || type === 'reject' || type === 'suspend' || type === 'unsuspend' || type === 'endMeeting' || type === 'endVote'
						? 'danger'
						: type === 'accept' || type === 'excel'
							? 'green'
							: 'primary'
				}
				variant="filled"
				shape="circle"
				onClick={onClick}>
				<Icon
					width={svgWidth || (type === 'reject' ? 16 : type === 'reset_password' ? 18 : type === 'openAttendance' || type === 'endMeeting' ? 22 : 20)}
					height={
						svgHeight || (type === 'reject' ? 16 : type === 'reset_password' ? 18 : type === 'openAttendance' || type === 'endMeeting' ? 22 : 20)
					}
					style={{ transform: type === 'suspend' ? 'translateX(-2px)' : undefined }}
					color={disabled ? '#bfbfbf' : type === 'endMeeting' || type === 'endVote' ? '#E41C1C' : '#2884ef'}
					name={type === 'download' ? 'download2' : type === 'accept' ? 'listBtnCheck' : type === 'reject' ? 'listBtnReject' : type}
				/>
			</Button>
		</Tooltip>
	);
};

export default ListButton;
